angular.module('gym.contacts').factory('Notes', ["Restangular", "$rootScope", function(Restangular, $rootScope) {
  var Notes;
  Notes = function() {
    var params;
    params = $rootScope.toParams;
    return Restangular.one('gyms', params.gymId).one('contacts', params.contactId).all('notes');
  };
  return Notes;
}]);
